import Grid from "@material-ui/core/Grid";
import React from "react";
import { FlyerDetailPageTabPageDetailsProductsProps } from "./flyer-detail-page-tab-page-details-products.props";

export const FlyerDetailPageTabPageDetailsProducts = (
  props: FlyerDetailPageTabPageDetailsProductsProps
) => (
  <Grid item={true} xs={2} sm={2} md={2} lg={2}>
    {((props.numberOfProducts as number) > 0 ? ((props.numberOfProducts as number) > 1 ? props.numberOfProducts +" Products" : "1 Product") : "No Products")}
  </Grid>
);
